import { jsx, jsxs } from "react/jsx-runtime";
import { c } from "react-compiler-runtime";
import { useEffect, useState } from "react";
import classnames from "classnames";
import { Box } from "../Box/index.js";
import { Typography } from "../Typography/index.js";
import { LinkColor, LinkSize } from "./Link.types.js";
import { useStyles } from "./Link.styles.js";
function _define_property(obj, key, value) {
    if (key in obj) Object.defineProperty(obj, key, {
        value: value,
        enumerable: true,
        configurable: true,
        writable: true
    });
    else obj[key] = value;
    return obj;
}
function _object_spread(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = null != arguments[i] ? arguments[i] : {};
        var ownKeys = Object.keys(source);
        if ("function" == typeof Object.getOwnPropertySymbols) ownKeys = ownKeys.concat(Object.getOwnPropertySymbols(source).filter(function(sym) {
            return Object.getOwnPropertyDescriptor(source, sym).enumerable;
        }));
        ownKeys.forEach(function(key) {
            _define_property(target, key, source[key]);
        });
    }
    return target;
}
function Link_ownKeys(object, enumerableOnly) {
    var keys = Object.keys(object);
    if (Object.getOwnPropertySymbols) {
        var symbols = Object.getOwnPropertySymbols(object);
        if (enumerableOnly) symbols = symbols.filter(function(sym) {
            return Object.getOwnPropertyDescriptor(object, sym).enumerable;
        });
        keys.push.apply(keys, symbols);
    }
    return keys;
}
function _object_spread_props(target, source) {
    source = null != source ? source : {};
    if (Object.getOwnPropertyDescriptors) Object.defineProperties(target, Object.getOwnPropertyDescriptors(source));
    else Link_ownKeys(Object(source)).forEach(function(key) {
        Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
    });
    return target;
}
function _object_without_properties(source, excluded) {
    if (null == source) return {};
    var target = {}, sourceKeys, key, i;
    if ("u" > typeof Reflect && Reflect.ownKeys) {
        sourceKeys = Reflect.ownKeys(Object(source));
        for(i = 0; i < sourceKeys.length; i++){
            key = sourceKeys[i];
            if (!(excluded.indexOf(key) >= 0)) {
                if (Object.prototype.propertyIsEnumerable.call(source, key)) target[key] = source[key];
            }
        }
        return target;
    }
    target = _object_without_properties_loose(source, excluded);
    if (Object.getOwnPropertySymbols) {
        sourceKeys = Object.getOwnPropertySymbols(source);
        for(i = 0; i < sourceKeys.length; i++){
            key = sourceKeys[i];
            if (!(excluded.indexOf(key) >= 0)) {
                if (Object.prototype.propertyIsEnumerable.call(source, key)) target[key] = source[key];
            }
        }
    }
    return target;
}
function _object_without_properties_loose(source, excluded) {
    if (null == source) return {};
    var target = {}, sourceKeys = Object.getOwnPropertyNames(source), key, i;
    for(i = 0; i < sourceKeys.length; i++){
        key = sourceKeys[i];
        if (!(excluded.indexOf(key) >= 0)) {
            if (Object.prototype.propertyIsEnumerable.call(source, key)) target[key] = source[key];
        }
    }
    return target;
}
const isRouterProps = (props)=>Object.prototype.hasOwnProperty.call(props, 'to');
const isHrefProps = (props)=>Object.prototype.hasOwnProperty.call(props, 'href');
const isButtonProps = (props)=>Object.prototype.hasOwnProperty.call(props, 'onClick');
const typographyMapping = {
    large: 'subtitle1',
    medium: 'subtitle2',
    small: 'body3',
    extraSmall: 'caption'
};
const loadReactRouterLink = ()=>import("react-router").then(({ Link: ReactRouterLink })=>ReactRouterLink);
const DefaultRouterLink = (t0)=>{
    const $ = c(8);
    let children;
    let props;
    let to;
    if ($[0] !== t0) {
        ({ to, children } = t0), props = _object_without_properties(t0, [
            "to",
            "children"
        ]);
        $[0] = t0;
        $[1] = children;
        $[2] = props;
        $[3] = to;
    } else {
        children = $[1];
        props = $[2];
        to = $[3];
    }
    let t1;
    if ($[4] !== children || $[5] !== props || $[6] !== to) {
        t1 = /*#__PURE__*/ jsx("a", _object_spread_props(_object_spread({
            href: to
        }, props), {
            children: children
        }));
        $[4] = children;
        $[5] = props;
        $[6] = to;
        $[7] = t1;
    } else t1 = $[7];
    return t1;
};
let CacheRouterLink = null;
const Link = (props)=>{
    const $ = c(61);
    const { size: t0, variant: t1, disabled: t2, stroke: t3, startIcon, endIcon, children, onCustomAction, iconAlign, backLink, display, testId } = props;
    const size = void 0 === t0 ? "medium" : t0;
    const variant = void 0 === t1 ? "primary" : t1;
    const disabled = void 0 === t2 ? false : t2;
    const stroke = void 0 === t3 ? true : t3;
    const [RouterLink, setRouterLink] = useState(_temp);
    let t4;
    let t5;
    if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
        t4 = ()=>{
            if (CacheRouterLink) return;
            let mounted = true;
            loadReactRouterLink().then((ReactRouterLink)=>{
                if (!mounted) return;
                CacheRouterLink = ReactRouterLink;
                if (null !== CacheRouterLink) setRouterLink(_temp2);
            }).catch(_temp3);
            return ()=>{
                mounted = false;
            };
        };
        t5 = [];
        $[0] = t4;
        $[1] = t5;
    } else {
        t4 = $[0];
        t5 = $[1];
    }
    useEffect(t4, t5);
    const t6 = LinkSize[size];
    const t7 = LinkColor[variant];
    const t8 = "simple" === variant ? false : stroke;
    let t9;
    if ($[2] !== backLink || $[3] !== disabled || $[4] !== display || $[5] !== iconAlign || $[6] !== t6 || $[7] !== t7 || $[8] !== t8) {
        t9 = {
            size: t6,
            color: t7,
            stroke: t8,
            disabled,
            iconAlign,
            backLink,
            display
        };
        $[2] = backLink;
        $[3] = disabled;
        $[4] = display;
        $[5] = iconAlign;
        $[6] = t6;
        $[7] = t7;
        $[8] = t8;
        $[9] = t9;
    } else t9 = $[9];
    const { classes } = useStyles(t9);
    let t10;
    if ($[10] !== disabled || $[11] !== onCustomAction) {
        t10 = (e)=>{
            if (disabled) return void (null == e || e.preventDefault());
            null == onCustomAction || onCustomAction();
        };
        $[10] = disabled;
        $[11] = onCustomAction;
        $[12] = t10;
    } else t10 = $[12];
    const handleAction = t10;
    let t11;
    if ($[13] !== disabled || $[14] !== handleAction || $[15] !== props) {
        t11 = (e_0)=>{
            if (disabled) return void e_0.preventDefault();
            e_0.preventDefault();
            if (isButtonProps(props)) {
                props.onClick(e_0);
                handleAction();
            }
        };
        $[13] = disabled;
        $[14] = handleAction;
        $[15] = props;
        $[16] = t11;
    } else t11 = $[16];
    const buttonOnClick = t11;
    let t12;
    if ($[17] !== variant) {
        t12 = "simple" === variant ? {
            display: "inline"
        } : {
            display: "flex",
            alignItems: "center"
        };
        $[17] = variant;
        $[18] = t12;
    } else t12 = $[18];
    let t13;
    if ($[19] !== children || $[20] !== classes.icon || $[21] !== classes.startIcon || $[22] !== startIcon) {
        t13 = startIcon && /*#__PURE__*/ jsx(Box, {
            className: classnames(classes.icon, !!children && classes.startIcon),
            children: startIcon
        });
        $[19] = children;
        $[20] = classes.icon;
        $[21] = classes.startIcon;
        $[22] = startIcon;
        $[23] = t13;
    } else t13 = $[23];
    let t14;
    if ($[24] !== children || $[25] !== size) {
        t14 = children && /*#__PURE__*/ jsx(Typography, {
            color: "inherit",
            component: "span",
            variant: typographyMapping[size],
            "data-testid": "link-typography",
            children: children
        });
        $[24] = children;
        $[25] = size;
        $[26] = t14;
    } else t14 = $[26];
    let t15;
    if ($[27] !== children || $[28] !== classes.endIcon || $[29] !== classes.icon || $[30] !== endIcon) {
        t15 = endIcon && /*#__PURE__*/ jsx(Box, {
            className: classnames(classes.icon, !!children && classes.endIcon),
            children: endIcon
        });
        $[27] = children;
        $[28] = classes.endIcon;
        $[29] = classes.icon;
        $[30] = endIcon;
        $[31] = t15;
    } else t15 = $[31];
    let t16;
    if ($[32] !== t12 || $[33] !== t13 || $[34] !== t14 || $[35] !== t15) {
        t16 = /*#__PURE__*/ jsxs(Box, _object_spread_props(_object_spread({}, t12), {
            children: [
                t13,
                t14,
                t15
            ]
        }));
        $[32] = t12;
        $[33] = t13;
        $[34] = t14;
        $[35] = t15;
        $[36] = t16;
    } else t16 = $[36];
    const content = t16;
    let t17;
    if ($[37] !== props) {
        t17 = isButtonProps(props) && props.className;
        $[37] = props;
        $[38] = t17;
    } else t17 = $[38];
    const t18 = disabled && classes.disabledLink;
    let t19;
    if ($[39] !== classes.link || $[40] !== t17 || $[41] !== t18) {
        t19 = classnames(classes.link, t17, t18);
        $[39] = classes.link;
        $[40] = t17;
        $[41] = t18;
        $[42] = t19;
    } else t19 = $[42];
    const styles = t19;
    if (isRouterProps(props)) {
        const t20 = testId || "router-link";
        let t21;
        if ($[43] !== RouterLink || $[44] !== content || $[45] !== handleAction || $[46] !== props.to || $[47] !== styles || $[48] !== t20) {
            t21 = /*#__PURE__*/ jsx(RouterLink, {
                onClick: handleAction,
                to: props.to,
                className: styles,
                "data-testid": t20,
                children: content
            });
            $[43] = RouterLink;
            $[44] = content;
            $[45] = handleAction;
            $[46] = props.to;
            $[47] = styles;
            $[48] = t20;
            $[49] = t21;
        } else t21 = $[49];
        return t21;
    }
    if (isHrefProps(props)) {
        const t20 = testId || "link-a";
        let t21;
        if ($[50] !== content || $[51] !== props.href || $[52] !== props.target || $[53] !== styles || $[54] !== t20) {
            t21 = /*#__PURE__*/ jsx("a", {
                href: props.href,
                target: props.target,
                className: styles,
                "data-testid": t20,
                children: content
            });
            $[50] = content;
            $[51] = props.href;
            $[52] = props.target;
            $[53] = styles;
            $[54] = t20;
            $[55] = t21;
        } else t21 = $[55];
        return t21;
    }
    const t20 = testId || "link-btn";
    let t21;
    if ($[56] !== buttonOnClick || $[57] !== content || $[58] !== styles || $[59] !== t20) {
        t21 = /*#__PURE__*/ jsx("a", {
            href: "#",
            className: styles,
            onClick: buttonOnClick,
            "data-testid": t20,
            children: content
        });
        $[56] = buttonOnClick;
        $[57] = content;
        $[58] = styles;
        $[59] = t20;
        $[60] = t21;
    } else t21 = $[60];
    return t21;
};
function _temp() {
    return null != CacheRouterLink ? CacheRouterLink : DefaultRouterLink;
}
function _temp2() {
    return CacheRouterLink;
}
function _temp3() {
    CacheRouterLink = DefaultRouterLink;
}
export { Link };
